import React, { useEffect, useState } from 'react';
import { InputSearchGray, Layout } from '../../../components';
import { useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import ScrollItemEvent from '../../../components/moleculs/ScrollItem/ScrollItemEvent';
import {
	postDataPage,
	setPageNo,
	setPageSize,
} from '../../../redux/eventsSlice';

const AllEvent = () => {
	const [searchParams, setSearchParams] = useSearchParams();
	const [keyword, setKeyword] = useState(searchParams.get('keyword') || '');

	const dispatch = useDispatch<any>();

	const getEventList = async (page: number, pageSize: number) => {
		const params = {
			pageNo: 0,
			pageSize: 10,
			sortType: 'DESC',
			filter: [
				{
					key: 'name',
					value: keyword,
					operation: 'MATCH',
					conjunction: 'or',
				},
				{
					key: 'content',
					value: keyword,
					operation: 'MATCH',
					conjunction: 'or',
				},
				{
					key: 'content_plain',
					value: keyword,
					operation: 'MATCH',
					conjunction: 'or',
				},
				{
					key: 'active',
					value: true,
					operation: 'EQUAL',
					conjunction: 'and',
				},
			],
		};
		dispatch(postDataPage(params));
		dispatch(setPageNo(page));
		dispatch(setPageSize(pageSize));
	};

	useEffect(() => {
		getEventList(0, 10);
	}, []);

	return (
		<Layout
			title="Event"
			showNavBar={true}
			showNavigation={false}
		>
			<div className="mt-[4rem]">
				<div className="flex gap-5 justify-between items-center ">
					<InputSearchGray
						value={keyword}
						onChange={(e) => {
							setKeyword(e.target.value);
						}}
						onKeyDown={(e) => {
							if (e.key === 'Enter') {
								getEventList(0, 10);
							}
						}}
						icon={'FaSistrix'}
						placeholder="Cari Informasi Berita"
					/>
				</div>
				<div className="mt-5">
					<ScrollItemEvent
						keyword={keyword}
						fix={false}
					/>
				</div>
			</div>
		</Layout>
	);
};

export default AllEvent;
